import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.546 2.203a.835.835 0 0 0-1.092 0l-6 5.19a.835.835 0 0 0-.29.632V16.1H2.4a.835.835 0 1 0 0 1.67h10.3a.835.835 0 1 0 0-1.67H4.835V8.406L10 3.94l5.165 4.467v8.529c0 .461.374.835.835.835h1.6a.835.835 0 1 0 0-1.67h-.765V8.025a.835.835 0 0 0-.289-.632z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M6.067 10.035c0-.46.373-.833.833-.833h1.667a.833.833 0 0 1 0 1.666H6.9a.833.833 0 0 1-.833-.833M6.9 12.185a.833.833 0 1 0 0 1.667h1.667a.833.833 0 0 0 0-1.667zM11.334 12.185a.833.833 0 1 0 0 1.667h1.667a.833.833 0 0 0 0-1.667zM11.334 9.202a.833.833 0 1 0 0 1.666h1.667a.833.833 0 0 0 0-1.666zM10.9 7.135a.9.9 0 1 1-1.8 0 .9.9 0 0 1 1.8 0"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }